export const exportResearch = {
  deckUrl: 'https://cdn.magicpatterns.com/uploads/2spCjx7AGPz69cTm3aEAkP/103fba_c493e00744c249d6a06e87c622bf9052.pdf',
  objective:
    'Identify digital behavior and how users perceive the new export update, and whether using it is clear and intuitive.',
  facts: [
    { label: 'Method', value: 'Initial interview + prototype tasks' },
    { label: 'Testers', value: '3 sellers who asked for export' },
    { label: 'Profile', value: 'Full and part-time, 30–45' },
    { label: 'Sessions', value: 'Remote · pilot Oct 15–16, test Oct 26' },
  ],
  interviewInsights: [
    'Keeping up with inventory changes is hard: sellers track them across multiple platforms.',
    'They need to choose what to export, and in which order.',
    'Listed date is essential. Most sellers calculate how long an item took to sell.',
    'On Poshmark and Mercari, sellers find CSV export under “Settings” or “My account”.',
  ],
  hypotheses: [
    {
      hypothesis: 'Users expect to find export on the Settings page.',
      task: 'You need to export your items. How would you do it?',
      result: 'Not everyone looked in Settings.',
      change: 'Added an “Export to .CSV” link next to the Inventory title.',
      tone: 'changed' as const,
    },
    {
      hypothesis: 'Users won’t ask for extra information or look for other headers.',
      task: 'Export your items from November 12 to 13.',
      result: 'The headers were fine, but sellers wanted more.',
      change: 'Added sold and shipped dates to the export headers.',
      tone: 'changed' as const,
    },
    {
      hypothesis: 'Users finish the export without blockers and understand it after one use.',
      task: 'Export your inventory from November 2 to 12, without the secondary color.',
      result: 'Confirmed: the flow was clear and easy to use.',
      change: 'Kept the flow as designed.',
      tone: 'confirmed' as const,
    },
  ],
};
